import { defineComponent as _defineComponent } from 'vue'
import {
  computed, defineAsyncComponent, getCurrentInstance, onMounted, ref, watch,
} from 'vue';
import usePwaInstall from '@/composables/pwa-install';
import createApps from './util/create-apps';
import setLanguage from './plugins/i18n-locale';
import TimeZone from './model/TimeZone';
import { useVuetify } from './components/helpers/vue2-helpers';
import i18n from './plugins/i18n';
import store from './store/store';
import useActivityIndicator from './composables/activity-indicator';
import useBrowserHacks from './components/browserhacks/browserhacks';
import useToastInit from './composables/toast-init';
import usePwaUpdate from './composables/pwa-update';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

usePwaInstall();

const BrowserhackScrollbar = defineAsyncComponent(() => import('@/components/browserhacks/BrowserhackScrollbar.vue'));
const { applyBrowserhackScrollbar, browserhackClass } = useBrowserHacks();
const vuetify = useVuetify();
const { overlay } = useActivityIndicator();

const {
  snackbar, snackbarText, snackbarIcon, snackbarColor, snackbarTextColor, snackbarTimeout,
} = useToastInit();

const { updateAvailable, refreshApp } = usePwaUpdate();

// Handle Locale Change
const timeZoneCountry = computed(() => {
  const tzid = store.getters.timeZoneId;
  console.log(`[LOCALE] tzid: ${tzid}`);
  if (tzid === undefined) { return 'en-US'; }
  const cc = store.getters.sortedTimezones.find((tz: TimeZone) => tz.id === tzid)?.countryCode || 'US';
  console.log(`[LOCALE] ${cc}`);
  return cc;
});

watch(timeZoneCountry, () => {
  console.log(`[LOCALE] changed country: ${timeZoneCountry.value}`);
  setLanguage(i18n.locale.split('-')[0], timeZoneCountry.value ?? '');
});

// Add lang tag to document when locale changes
const locale = computed(() => i18n.locale);

const updateDocumentLanguage = () => { document.documentElement.lang = locale.value; };

watch(locale, () => {
  setLanguage(i18n.locale.split('-')[0], timeZoneCountry.value ?? '');
  updateDocumentLanguage();
});

//

// Add Root theme--dark class when theme is switched
const dark = computed(() => vuetify.theme.dark);

const updateDocumentTheme = () => {
  if (dark.value) {
    document.documentElement.classList.add('theme--dark');
  } else {
    document.documentElement.classList.remove('theme--dark');
  }
};

watch(dark, () => updateDocumentTheme());
//

// Update title of page with account name
const accountName = computed(() => store.state.settings.account.accountName);

const updatePageTitle = () => {
  const appTitle = process.env.VUE_APP_TITLE || '';
  document.title = accountName.value ? `${appTitle} - ${accountName.value}` : appTitle;
};

watch(accountName, () => updatePageTitle());

// Init language from default
setLanguage(i18n.locale.split('-')[0], timeZoneCountry.value ?? '');

onMounted(() => {
  // Insert App Version into Document Code as Comment
  const version = `${process.env.VUE_APP_TITLE} (${process.env.VUE_APP_VERSION})`;
  document.documentElement.appendChild(document.createComment(version));

  updateDocumentTheme();
  updateDocumentLanguage();
  updatePageTitle();
  createApps(getCurrentInstance()!.proxy);
});


return { __sfc: true,BrowserhackScrollbar, applyBrowserhackScrollbar, browserhackClass, vuetify, overlay, snackbar, snackbarText, snackbarIcon, snackbarColor, snackbarTextColor, snackbarTimeout, updateAvailable, refreshApp, timeZoneCountry, locale, updateDocumentLanguage, dark, updateDocumentTheme, accountName, updatePageTitle }
}

})